import { render, staticRenderFns } from "./ExperienceUser.vue?vue&type=template&id=981252f4&scoped=true"
import script from "./ExperienceUser.vue?vue&type=script&lang=ts"
export * from "./ExperienceUser.vue?vue&type=script&lang=ts"
import style0 from "./ExperienceUser.vue?vue&type=style&index=0&id=981252f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981252f4",
  null
  
)

export default component.exports